import React from "react";
import { Card } from "semantic-ui-react";
import ContactDisplayName from "../ContactDisplayName";
import CallPopup from "./CallPopup";

const style = {
  incomingAlert: {
    top: 0,
    right: 0,
    position: "fixed",
    // above the Meet Now modal (100000), so a new call can still be answered
    zIndex: 100001,
  },
};

function IncomingCallAlert({ name, number, label, children }) {
  return (
    <div style={style.incomingAlert}>
      <Card>
        <Card.Content>
          <Card.Header>
            {label && label.length > "" ? `${label} | ` : ""}{" "}
            <ContactDisplayName
              name={name}
              number={number}
              staleTime={300000}
            />
          </Card.Header>
          <Card.Meta>Incoming call</Card.Meta>
        </Card.Content>
        <Card.Content extra>{children}</Card.Content>
      </Card>
    </div>
  );
}

function Popup(props) {
  return <CallPopup position="bottom center" {...props} />;
}

export { Popup };
export default IncomingCallAlert;
